import { render, staticRenderFns } from "./addemp.vue?vue&type=template&id=5ff5119e&"
import script from "./addemp.vue?vue&type=script&lang=js&"
export * from "./addemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports